import { useState } from 'react';
import AdminSpecialTaskService from './AdminSpecialTaskService';

function useManageAdminSpecialTasks() {
    const [tasks, setTasks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshTasks = async (params = {}) => {
        setIsLoading(true);
        try {
            const response = await AdminSpecialTaskService.getAdminSpecialTasks(params);
            setTasks(response.data || []);
            setError(null);
        } catch (err) {
            console.log(err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const addTask = async (data) => {
        let result = true;
        setIsLoading(true);
        try {
            await AdminSpecialTaskService.addAdminSpecialTask(data);
            await refreshTasks();
        } catch (err) {
            result = false;
            setError(err.response?.data?.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result;
    };

    const editTask = async (taskId, data) => {
        setIsLoading(true);
        try {
            await AdminSpecialTaskService.editAdminSpecialTask(taskId, data);
            await refreshTasks();
        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    const deleteTask = async (taskId) => {
        setIsLoading(true);
        try {
            await AdminSpecialTaskService.deleteAdminSpecialTask(taskId);
            await refreshTasks();
        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        tasks,
        isLoading,
        error,
        addTask,
        editTask,
        deleteTask,
        refreshTasks
    };
}

export default useManageAdminSpecialTasks;
